import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ZpDataService} from '../services/zp-data.service';

@Component({
  selector: 'app-global-modal',
  templateUrl: './global-modal.component.html',
  styleUrls: ['./global-modal.component.scss']
})
export class GlobalModalComponent implements OnInit {
  @Input() public showModal: boolean;
  @Input() public count: boolean;
  @Input() public firstPara: string;
  @Input() public scdPara: string;
  @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public dialogAnswer: EventEmitter<string> = new EventEmitter<string>();
  constructor(private api:ZpDataService) { }

  ngOnInit() {
  }

  choice(myChoice) {
    if(myChoice ==="Yes"){
      this.api.refreshToken();
    }
    this.dialogAnswer.emit(myChoice);
    this.close();
  }

  close() {
    this.showModal = false;
    this.visibleChange.emit(this.showModal);
  }

}
